module.exports = __webpack_public_path__ + "img/icon_5_1.20e9fbfb.png";